<template>
  <div v-if="!loading" class="form-group">
    <label :for="elementId" class="control-label">{{ label }}</label>
    <select :id="elementId" v-model="assistantId"
            class="form-control" name="assistant"
            style="width: 100%;"></select>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import Openai from '../../common/openai'
const props = defineProps({
  id: String,
  type: String,
  idIndex: String,
  label: {
    type: String,
    default: 'OpenAI Assistant'
  }
})

const emit = defineEmits(['handleChange'])
const loading = ref(true)

const assistantId = ref(props.id || null)

const elementId = ref((props.idIndex) ? `ai-assistant-select-${props.idIndex}` : 'ai-assistant-select')

async function fetchAssistants() {
  let type = props.type || 'feedback'
  const openai = new Openai()
  let resp = await openai.getAssistantsByType(type)
  let assistants = resp.map(item => ({
    id: item.assistant_id,
    text: item.name
  }))

  if (assistants.length === 1) {
    assistantId.value = assistants[0].id
  }
  loading.value = false
  return assistants
}

onMounted(async () => {

  const assistants = await fetchAssistants()

  $(() => {
    const $selectEl = $(`#${elementId.value}`)
    const data = _.map(assistants, tag => ({
      id: tag.id,
      text: tag.text,
      selected: tag.id === assistantId.value
    }))
    $selectEl.select2({
      data: data
    }).on('change', function () {
      let selected = $selectEl.select2('data')
      emit('handleChange', selected[0].id)
      assistantId.value = selected[0].id
    })
  })

  if (assistantId.value) {
    emit('handleChange', assistantId.value)
  }

})
</script>
